import { Component, inject } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { StyleClassModule } from 'primeng/styleclass';
import { AppConfigurator } from './app.configurator';
import { LayoutService } from '../service/layout.service';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { Popover } from 'primeng/popover';
import { Select } from 'primeng/select';
import { AuthService } from '../../shared/services/auth.service';
import { CookieService } from 'ngx-cookie-service';
import { LoginStore } from '../../pages/login/stores/login.store';

@Component({
  selector: 'app-topbar',
  standalone: true,
  imports: [
    RouterModule,
    CommonModule,
    FormsModule,
    StyleClassModule,
    AppConfigurator,
    TranslatePipe,
    Popover,
    Select
  ],
  template: ` <div class="layout-topbar">
    <div class="layout-topbar-logo-container">
      <button class="layout-menu-button layout-topbar-action" (click)="layoutService.onMenuToggle()">
        <i class="pi pi-bars"></i>
      </button>
      <a class="layout-topbar-logo" routerLink="/">
        <img
          width="40px"
          height="40px"
          src="assets/images/logo.svg"
          [style.filter]="layoutService.isDarkTheme() ? 'brightness(0) invert(1)' : 'none'"
        />
        <span class="flex-none">{{ 'app.title' | translate }}</span>
      </a>
    </div>

    <div class="layout-topbar-actions">
      <div class="layout-config-menu">
        <button type="button" class="layout-topbar-action" (click)="toggleDarkMode()">
          <i
            [ngClass]="{
              pi: true,
              'pi-moon': layoutService.isDarkTheme(),
              'pi-sun': !layoutService.isDarkTheme()
            }"
          ></i>
        </button>
        <p-select
          [options]="langOptions"
          [(ngModel)]="selectedLang"
          optionLabel="label"
          optionValue="value"
          (onChange)="onChangeLang($event.value)"
          class="w-25 text-sm"
        />
        <div class="relative">
          <button
            class="layout-topbar-action layout-topbar-action-highlight"
            pStyleClass="@next"
            enterFromClass="hidden"
            enterActiveClass="animate-scalein"
            leaveToClass="hidden"
            leaveActiveClass="animate-fadeout"
            [hideOnOutsideClick]="true"
          >
            <i class="pi pi-palette"></i>
          </button>
          <app-configurator />
        </div>
      </div>

      <button
        class="layout-topbar-menu-button layout-topbar-action"
        pStyleClass="@next"
        enterFromClass="hidden"
        enterActiveClass="animate-scalein"
        leaveToClass="hidden"
        leaveActiveClass="animate-fadeout"
        [hideOnOutsideClick]="true"
      >
        <i class="pi pi-ellipsis-v"></i>
      </button>

      <div class="layout-topbar-menu">
        <div class="layout-topbar-menu-content">
          <button type="button" (click)="action.toggle($event)" class="layout-topbar-action">
            <i class="pi pi-user"></i>
            <p-popover #action>
              <div class="p-3">{{ 'common.label.name' | translate }}: {{ authService.getProfile().fullName }}</div>
              <div class="p-3">
                {{ 'common.label.role' | translate }}
                : {{ 'common.role.' + authService.getProfile().role | translate }}
              </div>
              <div
                (click)="onLogout()"
                class="p-3 cursor-pointer flex gap-4 place-items-center text-danger font-bold border-t"
              >
                <i class="pi pi-sign-out"></i> {{ 'common.label.logout' | translate }}
              </div>
            </p-popover>
          </button>
        </div>
      </div>
    </div>
  </div>`
})
export class AppTopbar {
  cookieService = inject(CookieService);
  loginStore = inject(LoginStore);

  langOptions = [
    { label: 'TH', value: 'th' },
    { label: 'EN', value: 'en' }
  ];
  selectedLang = this.cookieService.get('lang') || 'th';

  constructor(
    public layoutService: LayoutService,
    private translateService: TranslateService,
    public authService: AuthService
  ) {}

  toggleDarkMode() {
    this.layoutService.layoutConfig.update(state => ({
      ...state,
      darkTheme: !state.darkTheme
    }));
  }

  onChangeLang(lang: string) {
    this.cookieService.set('lang', lang, { path: '/' });
    this.translateService.use(lang);
  }

  onLogout() {
    this.loginStore.reset();
    this.authService.logout();
  }
}
